import ExternalLink from '../../components/ExternalLink'
import { Page } from '../types'

type NextStepsProps = { }

const render = () => {
    return <>
        <p>Congratulations! You should now have a working Gurobi installation. There are many sources
            available to learn more about the product. We have listed the most important ones below.
        </p>
        <h3>Documentation</h3>
        <ul>
            <li>The <ExternalLink href="https://www.gurobi.com/documentation/{version}/refman/index.html">reference manual</ExternalLink> gives a complete overview of the Gurobi API in all supported programming languages. It also describes general Gurobi concepts like parameters, callbacks, multi-objective features and more.</li>
            <li>The <ExternalLink href="https://www.gurobi.com/documentation/{version}/remoteservices/index.html">Remote Services manual</ExternalLink> describes in detail how Compute Server and Cluster Manager work. This includes the Rest API, authentication and distributed optimization.</li>
            <li>The <ExternalLink href="https://www.gurobi.com/documentation/{version}/cloud-guide/index.html">cloud guide</ExternalLink> shows how to use Gurobi Instant Cloud.</li>
        </ul>
        <h3>Examples</h3>
        <ul>
            <li>The <ExternalLink href="https://www.gurobi.com/documentation/{version}/examples/index.html">example tour</ExternalLink> is a walkthrough of the sample code included with Gurobi.</li>
            <li>The <ExternalLink href="https://github.com/Gurobi/modeling-examples">modeling examples</ExternalLink> are more extensive notebooks that show how to apply optimization with Gurobi to a wide variety of applications.</li>            
        </ul>
        <h3>Training</h3>
        <ul>
            <li>If you want to learn more about mathematical optimization with Gurobi, you may be interested
                in joining Gurobi Academy, our own e-learning system.
            </li>
            <li>Need dedicated, on-site training by Gurobi Experts? Have a look at 
                <ExternalLink href="https://www.gurobi.com/products/gurobi-compass/">Gurobi Compass</ExternalLink>.</li>
        </ul>
    </>
}


const NextSteps : Page<NextStepsProps> = { key: 'next-steps', title: 'Next steps', render }

export default NextSteps